import { Dispatch, SetStateAction, useCallback, useState } from "react";
import { Filter } from "../types";

type PolicyFilter = {
  setFilter: Dispatch<SetStateAction<Filter>>;
  resetFilters: () => void;
  filter: Filter;
};

export const initFilter: Filter = {
  policyId: null,
  showCustomized: false,
  showEdited: false,
};

/**
 * Manage the policy table filter state.
 *
 * Filters can be pinned so that changing org/group maintains the selected filters
 *
 */
const usePolicyFilter = (): PolicyFilter => {
  const [filter, setFilter] = useState(initFilter);

  const resetFilters = useCallback(() => {
    setFilter(initFilter);
  }, []);

  return {
    setFilter,
    resetFilters,
    filter,
  };
};

export default usePolicyFilter;
